import {
  AsphaltLotDate,
  AsphaltLotId,
  AsphaltShortName,
} from '../../filenameTemplateItems/instances/asphalt'
import {
  Tags,
  TagCategories,
} from '../../filenameTemplateItems/instances/classless'
import {
  asphalts,
  projects,
} from '../../filenameTemplateItems/instances/groups'
import { SimpleReportItem } from './SimpleReportItem'

export class AsphaltLotReportItem<
  ID extends Lowercase<string>,
  Name extends 'Asphalt Core Sheet' | 'Asphalt Lot',
  QueryParameter extends 'asphalt-core' | 'asphalt-lot',
  SampleFilename extends 'asphalt-core-sheet' | 'asphalt-lot'
> extends SimpleReportItem<
  ID,
  Name,
  'AsphaltLot',
  'Asphalt Lot',
  'asphaltLots',
  QueryParameter,
  'asphaltLotId',
  SampleFilename,
  'globalId'
> {
  constructor({
    description,
    ...options
  }: Pick<
    AsphaltLotReportItem<ID, Name, QueryParameter, SampleFilename>,
    'id' | 'queryParameter' | 'sampleFilename' | 'name'
  > & {
    description: 'CORE-SHEET' | 'LOT'
  }) {
    super({
      ...options,
      key: 'globalId',
      classType: 'AsphaltLot',
      classTypeName: 'Asphalt Lot',
      endpoint: 'asphaltLots',
      label: 'asphaltLotId',
      compatibleTemplateItems: [...projects, ...asphalts, Tags, TagCategories],
      afterClientProjectNumber: [
        { type: 'custom', text: '_' },
        { type: 'templateItem', templateItemId: AsphaltShortName.id },
        { type: 'custom', text: `_${description}_` },
        { type: 'templateItem', templateItemId: AsphaltLotDate.id },
        { type: 'custom', text: '_' },
        { type: 'templateItem', templateItemId: AsphaltLotId.id },
      ],
    })
  }
}
